module.exports = __webpack_public_path__ + "28d425674f60d516d6dccfeee10b4f4f.png";